import {Component, ElementRef, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {filter, Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {AngularFirestore, AngularFirestoreCollection} from "@angular/fire/compat/firestore";
import {ChildService} from "../../../../components/child/child.service";
import {FullChild} from "../../../../interfaces/FullChild";
import {HospitalService} from "../../../../services/hospital.service";
import {Hospitals} from "../../../../interfaces/Hospitals";
import {AngularFireDatabase, SnapshotAction} from "@angular/fire/compat/database";
import {MatSelectChange} from "@angular/material/select";
import {map, tap} from "rxjs/operators";
import {environment} from "../../../../../environments/environment";
import firebase from "firebase/compat";
import {ApexFill} from "ng-apexcharts";
import {ChartOptions} from "../../education-reports/impact-reports/impact-reports.component";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {ChangeEvent} from "@ckeditor/ckeditor5-angular";
import html2pdf from "html2pdf.js";
import {EmployeeService} from "../../../../services/employee.service";
import {Employee} from "../../../../interfaces/Employee";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {LogService} from "../../../../services/log.service";
import {UserData} from "../../../../auth.service";
import {join} from "lodash";

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {FinancialYearService} from "../../../../services/financial-year.service";
import {endOfDay} from '../../../../utils/date-range-format.service';


@Component({
    selector: 'app-challenges',
    templateUrl: './challenges.component.html',
    styleUrls: ['./challenges.component.scss']
})
export class ChallengesComponent implements OnInit, OnDestroy {
    private _destroyed$ = new Subject<void>();
    @ViewChild('content') content!: ElementRef;
    public Editor: any = ClassicEditor;
    userData!: UserData;
    externalUser: boolean = false;
    selectedAgeRange: string[] = []
    selectedGender: string = 'All';
    selectedCity: string = '';
    selectedHospital: string[] = [];
    remarks: any;
    hospital$: Observable<Hospitals[]>
    env = environment.productionMode
    displayedColumns = ['sr', 'childName', 'intervention', 'centreName', 'challenges', 'state', 'submittedBy']
    dataSource: MatTableDataSource<any>
    centres$: Observable<Centre[]>;
    allCentresList: Centre[] = [];
    childBycentre: Observable<FullChild[]> | undefined;
    startDate: Date | undefined | null = null;
    endDate: Date | undefined | null = null

    mState = [
        {code: "AN", name: "Andaman and Nicobar Islands"},
        {code: "AP", name: "Andhra Pradesh"},
        {code: "AR", name: "Arunachal Pradesh"},
        {code: "AS", name: "Assam"},
        {code: "BR", name: "Bihar"},
        {code: "CG", name: "Chandigarh"},
        {code: "CH", name: "Chhattisgarh"},
        {code: "DH", name: "Dadra and Nagar Haveli"},
        {code: "DD", name: "Daman and Diu"},
        {code: "DL", name: "Delhi"},
        {code: "GA", name: "Goa"},
        {code: "GJ", name: "Gujarat"},
        {code: "HR", name: "Haryana"},
        {code: "HP", name: "Himachal Pradesh"},
        {code: "JK", name: "Jammu and Kashmir"},
        {code: "JH", name: "Jharkhand"},
        {code: "KA", name: "Karnataka"},
        {code: "KL", name: "Kerala"},
        {code: "LD", name: "Lakshadweep"},
        {code: "MP", name: "Madhya Pradesh"},
        {code: "MH", name: "Maharashtra"},
        {code: "MN", name: "Manipur"},
        {code: "ML", name: "Meghalaya"},
        {code: "MZ", name: "Mizoram"},
        {code: "NL", name: "Nagaland"},
        {code: "OR", name: "Odisha"},
        {code: "PY", name: "Puducherry"},
        {code: "PB", name: "Punjab"},
        {code: "RJ", name: "Rajasthan"},
        {code: "SK", name: "Sikkim"},
        {code: "TN", name: "Tamil Nadu"},
        {code: "TS", name: "Telangana"},
        {code: "TR", name: "Tripura"},
        {code: "UK", name: "Uttarakhand"},
        {code: "UP", name: "Uttar Pradesh"},
        {code: "WB", name: "West Bengal"}]

    colors: any[] = [{backgroundColor: ["#0b5ba8", "#6114be", "#15dcdc"]}];
    selectedCentreCode: string[] | null = null
    selectedCentreName: string[] | null = null
    selectedHospitalCode: string[] = []
    baseRef: AngularFirestoreCollection<any>
    mShowChallengesChart = false
    mShowStatesChart = false
    public areaChartOptions!: Partial<ChartOptions>;
    public stateChartOptions!: Partial<ChartOptions>;
    selectedChallenges: string[] = [];
    _challengesFaced$: Observable<String[]>;
    counselorName: any;
    selectCenter:any;
    SelectCounselorName:any;
    employeedata!: Employee[];
    selectedCounselorName: string[] | null = []
    SelectedChallenges:any;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    selectedState: string[] = [];
    mFilteredData: any[] = []
    mAllData: any[] = []
    @ViewChild(MatSort) sort!: MatSort;

    constructor(private mCentreService: CentreService,
                private mFirestore: AngularFirestore,
                private childService: ChildService,
                private mDatabase: AngularFireDatabase,
                private readonly mSnackbar: MatSnackBar,
                private mHospitalService: HospitalService,
                private mLogService:LogService,
                private readonly financialYearService: FinancialYearService,
                private userService: EmployeeService,) {
        this.centres$ = this.mCentreService.getAllCentres().pipe(
            map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim()))),
            tap(centres => this.allCentresList = centres)
        );
        this.hospital$ = this.withHospitalNames(this.mHospitalService.getHospitalList())
      this.userData = JSON.parse(localStorage.getItem('userData')!) as UserData
      this.externalUser = this.userData.department === 'External User'
        console.log(this.hospital$)
        this.baseRef = this.mFirestore.collection<any>(`${this.env.counseling}/allSessions/sessions/`);
        this._challengesFaced$ = this.mDatabase.list<string>('types/Challenges Faced').valueChanges().pipe(
            map(challenges => challenges.filter(challenge => challenge !== 'No Complains').sort()),
            tap(list => this.allChallengeOptions = (list || []) as string[])
        );

        this.dataSource = new MatTableDataSource<any>()
      // alert(JSON.stringify(this.userData))
    }

    ngOnInit(): void {
        // Pre-fill the date range with the current financial year (search still requires an explicit click)
        const fy = this.financialYearService.getCurrentFinancialYear();
        this.startDate = fy.startDate;
        this.endDate = fy.endDate;

        // Fetch data based on initial filters
        this.fetchChallengesData();
        this.userService.getUsers().pipe(takeUntil(this._destroyed$)).subscribe(snapshotchanges => {
            this.employeedata = snapshotchanges.map(w => {
                let emp = w.payload.toJSON() as Employee;
                if (w.key != null) {
                    emp['id'] = w.key;
                }
                return emp;
            });

            const namesToRemove = ['Shilpa Pahuja', 'Mukti Panchamia'];

            this.counselorName = this.employeedata
                .filter(employee => employee.role === 'Counsellor' || employee?.role === 'Lead Counsellor' || employee?.role === 'Lead Counsellor' || employee.role === 'Sr Counsellor')
                .map(counsellingEmployee => counsellingEmployee.userName)
                .filter(counselorName => !namesToRemove.includes(counselorName)).sort();


        });

    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

  ClearAll(): void {
    // Reset all the form fields to their initial values
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.selectedAgeRange = [];
    this.selectedGender = 'All';
    this.selectedCity = '';
    this.selectedHospital = [];
    this.selectedHospitalCode = [];
    this.selectedState = [];
    this.remarks = null;
    this.selectCenter = [];
    this.selectedCentreCode = [];
    this.selectedCentreName = [];
    this.SelectedChallenges = [];
    this.selectedChallenges = [];
    this.SelectCounselorName = [];
    this.selectedCounselorName = [];
    this.dataSource.filter = '';  // Reset table filter
  }


  // Update data based on filter changes

    updateFilters(): void {
        this.fetchChallengesData();
    }

    private fetchChallengesData(): void {
        // Implement logic to fetch data based on filters
        // Update this.challengesData with the fetched data
    }

  getSelectedCentreNames(): string {
    return this.selectedCentres.map((c: any) => c.centreName).join(', ');
  }

  getSelectedHospitalNames(): string {
    return this.selectedHospitalsReal.join(', ');
  }

  getAgeRangeLabel(value: string): string {
    const ageRangeMap: { [key: string]: string } = {
      '1,2': '1-2 years',
      '2,4': '2-4 years',
      '4,8': '4-8 years',
      '8,14': '8-14 years'
    };
    return ageRangeMap[value] || value;
  }

  getSelectedAgeRangeLabels(): string {
    return this.selectedAgeRangesReal.map(range => this.getAgeRangeLabel(range)).join(', ');
  }

  getSelectedStateNames(): string {
    return this.selectedStatesReal.join(', ');
  }

  getSelectedChallengesNames(): string {
    return this.selectedChallengesReal.join(', ');
  }

  getSelectedCounselorNames(): string {
    return this.selectedCounsellorsReal.join(', ');
  }

  downloadExcel(): void {
    if (!this.dataSource || !this.dataSource.data || this.dataSource.data.length === 0) {
      this.mSnackbar.open('No data available to download', '', { duration: 3000 });
      return;
    }

    // Prepare clean data for Excel
    const excelData = this.dataSource.data.map((item: any, index: number) => ({
      'Sr No': index + 1,
      'Child Name': item.childName || '',
      'Session Date': item.date ? item.date.toDate().toLocaleDateString('en-GB') : '',
      'Session Type': item.type || '',
      'Intervention': item.interventions || '',
      'Challenges Faced': Array.isArray(item.challengesFaced)
        ? item.challengesFaced.join(', ')
        : item.challengesFaced || '',
      'State': item.state || '',
      'Centre Name': item.centreName || '',
      'Counsellor Name': item.submittedBy || ''
    }));

    // Create worksheet & workbook
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Challenges Report': worksheet },
      SheetNames: ['Challenges Report']
    };

    // Generate buffer
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    // Save file
    const file = new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    const fileName = `Challenges_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;
    saveAs(file, fileName);

    // Log activity (consistent with your app)
    this.mLogService.addLog({
      date: new Date().getTime(),
      section: 'Counselling Reports',
      action: 'Download Excel',
      description: 'Challenges Report Excel downloaded by user',
      currentIp: localStorage.getItem('currentip')!
    });

    this.mSnackbar.open('Excel downloaded successfully', '', { duration: 3000 });
  }




  // selectionChange handler — mirrors the real selection into selectedHospitalCode
  // and keeps the "Select All" tick synced when individual hospitals are toggled.
  searchHospital(_?: MatSelectChange) {
        if (Array.isArray(this.selectedHospital)) {
            const hasAll = this.selectedHospital.includes(this.ALL_HOSPITALS);
            const everyReal = this.allHospitalNames.length > 0
                && this.selectedHospitalsReal.length === this.allHospitalNames.length;

            if (hasAll && !everyReal) {
                this.selectedHospital = this.selectedHospitalsReal;
            } else if (!hasAll && everyReal) {
                this.selectedHospital = [this.ALL_HOSPITALS, ...this.selectedHospitalsReal];
            }
        }
        this.selectedHospitalCode = this.selectedHospitalsReal
        console.log(this.selectedHospitalCode)

    }

    applyFilter($event: Event) {
        const filterValue = (event?.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

    }

    // Sentinel value used by the "Select All" mat-option in the centre dropdown
    readonly ALL_CENTRES = 'ALL';

    // Real centre objects currently selected (excludes the "Select All" sentinel)
    get selectedCentres(): Centre[] {
        return Array.isArray(this.selectCenter)
            ? this.selectCenter.filter((c: any) => c && c.centreCode)
            : [];
    }

    // True when every available centre is selected
    get allCentresSelected(): boolean {
        return this.allCentresList.length > 0
            && this.selectedCentres.length === this.allCentresList.length;
    }

    // Click handler on the "Select All" row — sole authority on the all / none decision.
    // Runs AFTER Material has already toggled the sentinel option, so we read the
    // live state with .every() and flip it.
    toggleAllCentres() {
        const allSelected = this.allCentresList.length > 0
            && this.allCentresList.every(c => this.isCentreSelected(c));

        this.selectCenter = allSelected ? [] : [this.ALL_CENTRES, ...this.allCentresList];
        this.syncSelectedCentres();
    }

    private isCentreSelected(centre: Centre): boolean {
        return Array.isArray(this.selectCenter)
            && this.selectCenter.some((s: any) => s && s.centreCode === centre.centreCode);
    }

    // selectionChange handler — recomputes derived state and keeps the "Select All"
    // tick in sync when individual centres are toggled. The all / none decision that
    // originates from clicking the "Select All" row itself is owned by toggleAllCentres(),
    // which runs afterwards and has the final say.
    setSelectedCentreCode(_?: MatSelectChange) {
        if (Array.isArray(this.selectCenter)) {
            const hasAll = this.selectCenter.includes(this.ALL_CENTRES);
            const everyReal = this.allCentresList.length > 0
                && this.selectedCentres.length === this.allCentresList.length;

            if (hasAll && !everyReal) {
                this.selectCenter = this.selectedCentres;
            } else if (!hasAll && everyReal) {
                this.selectCenter = [this.ALL_CENTRES, ...this.selectedCentres];
            }
        }
        this.syncSelectedCentres();
    }

    private syncSelectedCentres() {
        const centres = this.selectedCentres;
        this.selectedCentreCode = centres.map(c => c.centreCode);
        this.selectedCentreName = centres.map(c => c.centreName);
        this.hospital$ = this.withHospitalNames(this.mHospitalService.getHospitalListByCentre(this.selectedCentreCode));
    }

    // ---- "Select All" support for the Hospital dropdown ----
    readonly ALL_HOSPITALS = '__ALL_HOSPITALS__';
    allHospitalNames: string[] = [];

    // Captures the full list of hospital names off whichever stream is currently bound
    private withHospitalNames(obs: Observable<Hospitals[]>): Observable<Hospitals[]> {
        return obs.pipe(tap(list => this.allHospitalNames = (list || []).map(h => h.hospitalName)));
    }

    // Hospitals actually selected (excludes the "Select All" sentinel)
    get selectedHospitalsReal(): string[] {
        return Array.isArray(this.selectedHospital)
            ? this.selectedHospital.filter(h => h !== this.ALL_HOSPITALS)
            : [];
    }

    toggleAllHospitals() {
        const allSelected = this.allHospitalNames.length > 0
            && this.allHospitalNames.every(h => this.selectedHospitalsReal.includes(h));

        this.selectedHospital = allSelected ? [] : [this.ALL_HOSPITALS, ...this.allHospitalNames];
        this.selectedHospitalCode = this.selectedHospitalsReal;
    }

    // ---- "Select All" support for the State dropdown ----
    readonly ALL_STATES = '__ALL_STATES__';

    get stateNames(): string[] {
        return this.mState.map(s => s.name);
    }

    // States actually selected (excludes the "Select All" sentinel)
    get selectedStatesReal(): string[] {
        return Array.isArray(this.selectedState)
            ? this.selectedState.filter(s => s !== this.ALL_STATES)
            : [];
    }

    toggleAllStates() {
        const names = this.stateNames;
        const allSelected = names.length > 0
            && names.every(s => this.selectedStatesReal.includes(s));

        this.selectedState = allSelected ? [] : [this.ALL_STATES, ...names];
    }

    // ---- "Select All" support for the Age Range dropdown ----
    readonly ALL_AGE_RANGES = '__ALL_AGES__';
    readonly ageRangeValues = ['1,2', '2,4', '4,8', '8,14'];

    get selectedAgeRangesReal(): string[] {
        return Array.isArray(this.selectedAgeRange)
            ? this.selectedAgeRange.filter(a => a !== this.ALL_AGE_RANGES)
            : [];
    }

    toggleAllAgeRanges() {
        const allSelected = this.ageRangeValues.every(a => this.selectedAgeRangesReal.includes(a));
        this.selectedAgeRange = allSelected ? [] : [this.ALL_AGE_RANGES, ...this.ageRangeValues];
    }

    // ---- "Select All" support for the Challenges Faced dropdown ----
    readonly ALL_CHALLENGES = '__ALL_CHALLENGES__';
    allChallengeOptions: string[] = [];

    get selectedChallengesReal(): string[] {
        return Array.isArray(this.SelectedChallenges)
            ? this.SelectedChallenges.filter((c: string) => c !== this.ALL_CHALLENGES)
            : [];
    }

    toggleAllChallenges() {
        const allSelected = this.allChallengeOptions.length > 0
            && this.allChallengeOptions.every(c => this.selectedChallengesReal.includes(c));

        this.SelectedChallenges = allSelected ? [] : [this.ALL_CHALLENGES, ...this.allChallengeOptions];
        this.selectedChallenges = this.selectedChallengesReal;
    }

    // ---- "Select All" support for the Counsellor Name dropdown ----
    readonly ALL_COUNSELLORS = '__ALL_COUNSELLORS__';

    get counsellorOptions(): string[] {
        return Array.isArray(this.counselorName) ? this.counselorName : [];
    }

    get selectedCounsellorsReal(): string[] {
        return Array.isArray(this.SelectCounselorName)
            ? this.SelectCounselorName.filter((c: string) => c !== this.ALL_COUNSELLORS)
            : [];
    }

    toggleAllCounsellors() {
        const opts = this.counsellorOptions;
        const allSelected = opts.length > 0
            && opts.every(c => this.selectedCounsellorsReal.includes(c));

        this.SelectCounselorName = allSelected ? [] : [this.ALL_COUNSELLORS, ...opts];
        this.selectedCounselorName = this.selectedCounsellorsReal;
    }


    MysearchData() {
        this.mFilteredData = []
        // alert(JSON.stringify(this.selectedCentreCode))
        let challenges: string[] = [];
        let states: string[] = [];
        let filteredChallenges: any[] = []

        if (this.startDate != null && this.endDate != null) {
            let myQuery: firebase.firestore.Query<any> = this.baseRef.ref;
            myQuery = myQuery.where('date', '>=', this.startDate);
            myQuery = myQuery.where('date', '<=', endOfDay(this.endDate));
            // Skip the centre filter when nothing / everything is selected (also avoids Firestore's `in` limit)
            if (this.selectedCentreCode != null && this.selectedCentreCode.length >= 1 && !this.allCentresSelected) {
                myQuery = myQuery.where('centreCode', 'in', this.selectedCentreCode);
            }

            myQuery.get().then(res => {
                {
                    this.mSnackbar.open('docs' + res.docs.length)._dismissAfter(3000)
                    this.mAllData = res.docs.map(y => y.data())  //CENTRE AND DATE RANGE

                    this.mFilteredData = this.mAllData

                    if (this.selectedGender != 'All') {
                        this.mFilteredData = this.mFilteredData.filter((x) => x.gender == this.selectedGender)
                    }

                    console.log(`selectedHospitalCode`, this.selectedHospitalCode)
                    try {
                        if (this.selectedHospitalCode[0] != "All" && this.selectedHospitalCode.length >= 1) {
                            const filteredData = this.mFilteredData.filter(item => this.selectedHospitalCode?.includes(item.hospital));

                            // Use a Set to remove duplicates efficiently
                            const uniqueData = new Set(filteredData.map(item => JSON.stringify(item)));

                            // Convert uniqueData back to an array of objects
                            this.mFilteredData = Array.from(uniqueData).map(item => JSON.parse(item));
                        }
                    } catch (e) {
                        console.log('ERROR:' + e)
                    }

                    if (this.selectedAgeRange != null && this.selectedAgeRange?.length >= 1 && this.selectedAgeRange[0] != 'All') {
                        console.log('into range')
                        console.log(this.selectedAgeRange)

                        this.selectedAgeRange.forEach(range => {
                            if (!range || range.indexOf(',') < 0) return; // skip the "Select All" sentinel
                            // let r =JSON.parse( range)
                            const r = range.split(",");

                            console.log(`${r[0]} ${r[1]}  `)
                            const filteredData = this.mFilteredData.filter((x) => x.age >= parseInt(r[0]) && x.age <= parseInt(r[1]));
                            console.log(this.mFilteredData.length)
                            // Use a Set to remove duplicates efficiently
                            const uniqueData = new Set(filteredData.map(item => JSON.stringify(item)));

                            // Convert uniqueData back to an array of objects
                            this.mFilteredData = filteredData
                        })


                    }

                    //
                    // if (this.selectedState != null && this.selectedState[0] != 'All') {
                    //     this.selectedState.forEach(it => {
                    //         this.mFilteredData = this.mFilteredData.filter((x) => x.state == it)
                    //     })
                    // }

                    if (this.selectedCounselorName != null && !this.selectedCounselorName[0] != null) {
                        this.selectedCounselorName.forEach(it => {
                            this.mFilteredData = this.mFilteredData.filter((x) => x.selectedCounselorName == it)
                        })
                    }

                    if (this.selectedChallenges != null && this.selectedChallenges[0] != "All") {

                        this.selectedChallenges.forEach(it => {
                            let c = this.mFilteredData.filter((x) => (x.challengesFaced).includes(it))
                            c.forEach(c1 => {
                                filteredChallenges.push(c1)
                            })
                            this.mFilteredData = filteredChallenges
                        })
                    }

                    try {
                        if (this.selectedState[0] != "All" && this.selectedState.length >= 1) {
                            const filteredData = this.mFilteredData.filter(item => this.selectedState?.includes(item.state));

                            // Use a Set to remove duplicates efficiently
                            const uniqueData = new Set(filteredData.map(item => JSON.stringify(item)));

                            // Convert uniqueData back to an array of objects
                            // this.mFilteredData = Array.from(uniqueData).map(item => JSON.parse(item));
                            this.mFilteredData = filteredData

                        }
                    } catch (e) {
                        console.log('ERROR:' + e)
                    }


                    console.log("filteredData", this.mFilteredData)
                    this.dataSource = new MatTableDataSource<any>(this.mFilteredData)
                    // this.dataSource.paginator = this.paginator
                    this.mFilteredData.forEach(item => {
                        if (item.challengesFaced && Array.isArray(item.challengesFaced)) {
                            challenges.push(...item.challengesFaced);
                        }

                        if (item.state != null && item.state != '') {
                            console.log('is State' + item.state)
                            states.push(item.state);
                        }
                    });

                    // Count frequency of challenges
                    const frequencyMap = new Map<string, number>();
                    // this.selectedChallenges.forEach(it=>{
                    //     const filteredData = this.mFilteredData.filter((x) => x.challengesFaced.includes(it));
                    //     console.log(this.mFilteredData.length)
                    //     // Use a Set to remove duplicates efficiently
                    //     const uniqueData = new Set(filteredData.map(item => JSON.stringify(item)));
                    //     // Convert uniqueData back to an array of objects
                    //     this.mFilteredData = Array.from(uniqueData).map(item => JSON.parse(item));
                    // })

                    // challenges =challenges.filter(x=>x.includes(this.selectedChallenges))

                    challenges.forEach(challenge => {
                        frequencyMap.set(challenge, (frequencyMap.get(challenge) || 0) + 1);
                    });


                    // Count frequency of interventions
                    const stateFrequencyMap = new Map<string, number>();
                    states.forEach(state => {
                        console.log('states', state)
                        stateFrequencyMap.set(state, (stateFrequencyMap.get(state) || 0) + 1);
                    });
// Extract Interventions labels and label counts
                    const mStateLables: string[] = Array.from(stateFrequencyMap.keys());
                    const mStateLabelCounts: number[] = Array.from(stateFrequencyMap.values());
                    // Extract Challenges labels and label counts

                    let mChallengesLabels: string[] = Array.from(frequencyMap.keys());
                    let mChallengesLabelCounts: number[] = Array.from(frequencyMap.values());
                    // Filter challenges labels and label counts based on selected challenges
                    let filteredChallengesLabels: string[] = [];
                    let filteredChallengesLabelCounts: number[] = [];
                    if (this.selectedChallenges.length >= 1) {
                        // Loop through each challenge label and count
                        for (let i = 0; i < mChallengesLabels.length; i++) {
                            const challengeLabel = mChallengesLabels[i];
                            const challengeLabelCount = mChallengesLabelCounts[i];

                            // Check if the challenge is in selectedChallenges
                            if (this.selectedChallenges.includes(challengeLabel)) {
                                // Add the challenge label and count to filtered arrays
                                filteredChallengesLabels.push(challengeLabel);
                                filteredChallengesLabelCounts.push(challengeLabelCount);
                            }

                        }
                        mChallengesLabels = filteredChallengesLabels
                        mChallengesLabelCounts = filteredChallengesLabelCounts
                    }

// Display extracted data for debugging
                    console.log('CHALLENGES LABELS:', mChallengesLabels);
                    console.log('CHALLENGES LABEL COUNT:', mChallengesLabelCounts);
                    console.log('States ', states);
                    console.log('STATE LABELS:', mStateLables);
                    console.log('STATE LABEL COUNT:', mStateLabelCounts);

                    this.showChallengesChart(mChallengesLabels, mChallengesLabelCounts)
                    // this.showStatesChart2(mStateLables, mStateLabelCounts)
                    this.mSnackbar.open(`${this.mFilteredData.length}`)._dismissAfter(3000)

                }
            })

        } else {
            this.mSnackbar.open('Please select a proper date range first', '', {
                panelClass: 'error',
                duration: 3000
            })
        }
    }


    getGender($event: MatSelectChange) {
        this.selectedGender = $event.value
        console.log(this.selectedGender)

    }


    private showStatesChart1(mStateLabels: string[], mStateCounts: number[]) {
        this.stateChartOptions = {
            series: [

                {
                    name: 'Count',
                    data: mStateCounts,
                },

            ],
            chart: {
                height: 350,
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                },
                foreColor: '#9aa0ac',
            },
            colors: ['#0e28a6', '#e83108'],
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: 'smooth',
            },
            xaxis: {
                type: 'category',
                categories: mStateLabels,
                // categories: [
                //     '2018-09-19',
                //     '2018-09-20',
                //     '2018-09-21',
                //     '2018-09-22',
                //     '2018-09-23',
                //     '2018-09-24',
                //     '2018-09-25',
                // ],
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                offsetX: 0,
                offsetY: 0,
            },
            grid: {
                show: true,
                borderColor: '#9aa0ac',
                strokeDashArray: 1,
            },
            tooltip: {
                theme: 'dark',
                marker: {
                    show: true,
                },
                x: {
                    show: true,
                },
            },
        };
        this.mShowStatesChart = true
    }

    private showStatesChart2(mStateLabels: string[], mStateCounts: number[]) {
        this.stateChartOptions = {
            series: [

                {
                    name: 'Count',
                    data: mStateCounts,
                },

            ],
            chart: {
                height: 350,
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                },
                foreColor: '#9aa0ac',
            },
            colors: ['#0e28a6', '#e83108'],
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: 'smooth',
            },
            xaxis: {
                type: 'category',
                categories: mStateLabels,
                // categories: [
                //     '2018-09-19',
                //     '2018-09-20',
                //     '2018-09-21',
                //     '2018-09-22',
                //     '2018-09-23',
                //     '2018-09-24',
                //     '2018-09-25',
                // ],
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                offsetX: 0,
                offsetY: 0,
            },
            grid: {
                show: true,
                borderColor: '#9aa0ac',
                strokeDashArray: 1,
            },
            tooltip: {
                theme: 'dark',
                marker: {
                    show: true,
                },
                x: {
                    show: true,
                },
            },
        };
        this.mShowStatesChart = true
    }

    private showChallengesChart(mChallengesLabels: string[], mChallengesLabelCharts: number[]) {
        // alert(this.selectedChallenges.length)
        let filteredChartData: number[] = []
        let filteredLabels: string[] = []
        if (mChallengesLabels.length >= 1) {
            // alert(JSON.stringify(this.selectedChallenges))
            if (this.selectedChallenges.length >= 1) {
                console.log('mChallenges')
                this.selectedChallenges.forEach(it => {
                    const i = this.selectedChallenges.findIndex(x => x == it)
                    filteredLabels.push(it)
                    filteredChartData.push(mChallengesLabelCharts[i])

                })
            } else if (this.selectedChallenges.length == 0) {
                // alert('into')
                filteredChartData = mChallengesLabelCharts
                filteredLabels = mChallengesLabels
            }

        }

        this.areaChartOptions = {
            series: [
                {
                    name: 'Count',
                    data: filteredChartData,
                },
                // {
                //   name: 'Oral',
                //   data: [0, 0, 0],
                // },
            ],
            chart: {
                height: 350,
                type: 'bar',
                toolbar: {
                    show: true,
                },
                foreColor: '#9aa0ac',
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                distributed: true, // Ensure bars are colored individually
              }
            },
            colors: ['#4379F2', '#EF5A6F', '#387F39', '#6439FF', '#FF885B', '#48CFCB', '#FABC3F', '#A28B55', '#921A40',
            '#85f76c', '#8E44AD', '#1F8A70', '#b58561', '#2C3E50', '#E74C3C', '#9B59B6', '#3498DB', '#F1C40F',
            '#16A085', '#D35400', '#1a628f', '#C0392B', '#27AE60', '#BDC3C7', '#FF6347', '#FF1493', '#6A5ACD', '#FFD700'],
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: 'stepline',
            },
            xaxis: {
                type: 'category',
                categories: filteredLabels,
                // categories: [
                //     '2018-09-19',
                //     '2018-09-20',
                //     '2018-09-21',
                //     '2018-09-22',
                //     '2018-09-23',
                //     '2018-09-24',
                //     '2018-09-25',
                // ],
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                offsetX: 0,
                offsetY: 0,
            },
            grid: {
                show: true,
                borderColor: '#9aa0ac',
                strokeDashArray: 1,
            },
            tooltip: {
                theme: 'dark',
                marker: {
                    show: true,
                },
                x: {
                    show: true,
                },
            },
        };
        this.mShowChallengesChart = true
    }

    printDoc() {

        const content = this.content.nativeElement;

        // Configure options for the PDF
        const options = {
            margin: 10,
            filename: `Challenges Report.pdf`,
            image: {type: 'jpeg', quality: 0.98},
            html2canvas: {scale: 1},
            jsPDF: {unit: 'mm', format: 'a4', orientation: 'portrait'}
        };

        // Use html2pdf.js to generate the PDF
        html2pdf()
            .from(content)
            .set(options)
            .save();
      let activity = {
        date: new Date().getTime(),
        section: 'Counselling Reports',
        action: 'Receipt',
        description: `Counselling Receipt Dowonload Challenges Report by user`,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)
    }


    protected readonly ClassicEditor = ClassicEditor;

    onEditorChange($event: ChangeEvent<any>) {
        console.log('editor called!!!')
        this.remarks = $event.editor.getData();
        // this.highlights =this.getSanitizedHTML(updatedData)
        // this.highlights =updatedData

        console.log(this.remarks);

    }

    getSelectedChallenges(_?: MatSelectChange) {
        // Keep the "Select All" tick synced when individual challenges are toggled
        if (Array.isArray(this.SelectedChallenges)) {
            const hasAll = this.SelectedChallenges.includes(this.ALL_CHALLENGES);
            const everyReal = this.allChallengeOptions.length > 0
                && this.selectedChallengesReal.length === this.allChallengeOptions.length;

            if (hasAll && !everyReal) {
                this.SelectedChallenges = this.selectedChallengesReal;
            } else if (!hasAll && everyReal) {
                this.SelectedChallenges = [this.ALL_CHALLENGES, ...this.selectedChallengesReal];
            }
        }
        this.selectedChallenges = this.selectedChallengesReal
        console.log(this.selectedChallenges)
    }

    getCounselorName(_?: any) {
        // Keep the "Select All" tick synced when individual counsellors are toggled
        if (Array.isArray(this.SelectCounselorName)) {
            const hasAll = this.SelectCounselorName.includes(this.ALL_COUNSELLORS);
            const everyReal = this.counsellorOptions.length > 0
                && this.selectedCounsellorsReal.length === this.counsellorOptions.length;

            if (hasAll && !everyReal) {
                this.SelectCounselorName = this.selectedCounsellorsReal;
            } else if (!hasAll && everyReal) {
                this.SelectCounselorName = [this.ALL_COUNSELLORS, ...this.selectedCounsellorsReal];
            }
        }
        this.selectedCounselorName = this.selectedCounsellorsReal
    }

    getStates(_?: any) {
        // Keep the "Select All" tick synced when individual states are toggled
        if (Array.isArray(this.selectedState)) {
            const hasAll = this.selectedState.includes(this.ALL_STATES);
            const everyReal = this.stateNames.length > 0
                && this.selectedStatesReal.length === this.stateNames.length;

            if (hasAll && !everyReal) {
                this.selectedState = this.selectedStatesReal;
            } else if (!hasAll && everyReal) {
                this.selectedState = [this.ALL_STATES, ...this.selectedStatesReal];
            }
        }
    }

    getAgeRange(_?: any) {
        // Keep the "Select All" tick synced when individual age ranges are toggled
        if (Array.isArray(this.selectedAgeRange)) {
            const hasAll = this.selectedAgeRange.includes(this.ALL_AGE_RANGES);
            const everyReal = this.selectedAgeRangesReal.length === this.ageRangeValues.length;

            if (hasAll && !everyReal) {
                this.selectedAgeRange = this.selectedAgeRangesReal;
            } else if (!hasAll && everyReal) {
                this.selectedAgeRange = [this.ALL_AGE_RANGES, ...this.selectedAgeRangesReal];
            }
        }
    }

    searchData() {
        this.mFilteredData = []
        if (!this.startDate || !this.endDate) {
            this.mSnackbar.open('Please select a proper date range first', '', {
                panelClass: 'error',
                duration: 3000
            });
            return;
        }

        let myQuery: firebase.firestore.Query<any> = this.baseRef.ref;
        myQuery = myQuery.where('date', '>=', this.startDate).where('date', '<=', endOfDay(this.endDate));

        console.log('in searchData selectedCentreCode', this.selectedCentreCode)
        // Skip the centre filter when everything is selected (also avoids Firestore's `in` limit)
        if (this.selectedCentreCode != null && this.selectedCentreCode.length >= 1 && !this.allCentresSelected) {
            myQuery = myQuery.where('centreCode', 'in', this.selectedCentreCode);

        }
        // if (this.selectedChallenges != null && this.selectedChallenges.length >= 1) {
        //     console.log('CHALLENGES FACED SELECTED QUERYING DATA',this.selectedChallenges)
        //     myQuery = myQuery.where('challengesFaced', 'in', this.selectedChallenges);
        //
        // }


        myQuery.get().then(res => {

          let activity = {
            date: new Date().getTime(),
            section: 'Counselling Reports',
            action: 'Filter',
            description: `Counselling Filter Display chart Challenges Report by user`,
            currentIp: localStorage.getItem('currentip')!
          }
          this.mLogService.addLog(activity)

            this.mSnackbar.open(`Docs: ${res.docs.length}`, '', {duration: 3000});
            const docs = res.docs;
            const docsData = docs.map(doc => doc.data()); // Fetch data in a single step

            // Handle missing states with reduced iterations
            for (let i = 0; i < docsData.length; i++) {
                docsData[i].state = docsData[i].state ?? 'NA';
            }

            this.mAllData = docsData;
            // alert(docsData.length)
            this.mFilteredData = [...this.mAllData]
            if (this.mFilteredData.length >= 1) this.applyFilters();
            if (this.mFilteredData.length >= 1) this.processChartData();
            this.dataSource = new MatTableDataSource(this.mFilteredData)
            this.dataSource.paginator = this.paginator
            this.mSnackbar.open(`Docs: ${this.mFilteredData.length}`, '', {duration: 3000});
        });


    }

    private applyFilters() {
        this.mFilteredData = [...this.mAllData];

        if (this.selectedGender != 'All') {
            this.mFilteredData = this.mFilteredData.filter(x => x.gender === this.selectedGender);
        }
        console.log(`After Gender Filter`, this.mFilteredData.length)
        if (this.selectedHospitalCode.length >= 1) {
            this.mFilteredData = this.mFilteredData.filter(item => this.selectedHospitalCode.includes(item.hospital));
        }
        // console.log(`After Hospital Filter`, this.mFilteredData.length)

        if (this.selectedAgeRange.length >= 1) {
            this.selectedAgeRange.forEach(range => {
                if (!range || range.indexOf(',') < 0) return; // skip the "Select All" sentinel
                const [minAge, maxAge] = range.split(',').map(Number);
                this.mFilteredData = this.mFilteredData.filter(x => x.age >= minAge && x.age <= maxAge);
            });
        }
        // console.log(`After Age Filter`, this.mFilteredData.length)

        // @ts-ignore
        if (this.selectedCounselorName.length > 0) {
            this.mFilteredData = this.mFilteredData.filter(x => this.selectedCounselorName?.includes(x.submittedBy));
        }
        // console.log(`After Counsellor Filter`, this.mFilteredData.length)
        //
        // if (this.selectedChallenges.length >= 1) {
        //     const filteredChallenges: string[] = [];
        //     this.selectedChallenges.forEach(challenge => {
        //         console.log('filtering challenge',challenge)
        //         const filtered = this.mFilteredData.filter(x => x.challengesFaced.includes(challenge));
        //         console.log(filtered.length)
        //         filteredChallenges.push(...filtered);
        //
        //     });
        //
        //     this.mFilteredData = filteredChallenges;
        // }

        if (this.selectedChallenges.length >= 1) {
            const filteredChallenges: any[] = [];

            // Use a forEach loop for better readability and potential performance optimization
            this.selectedChallenges.forEach((challenge) => {
                // Filter the data efficiently using the includes method
                const filtered = this.mFilteredData.filter((x) => x.challengesFaced.includes(challenge));

                // Append the filtered results to the filteredChallenges array
                filteredChallenges.push(...filtered);
            });

            // Set the filtered data to the updated filteredChallenges array
            this.mFilteredData = filteredChallenges;

            // Optionally, log the filtered data for debugging or verification
            console.log('Filtered data:', this.mFilteredData);
        }
        console.log(`After Challendges Filter`, this.mFilteredData.length)

        if (this.selectedState.length >= 1) {
            // const filteredStates:string[]=[]
            this.mFilteredData = this.mFilteredData.filter(item => this.selectedState.includes(item.state));
            // this.mFilteredData= []
            this.mFilteredData.forEach(it => {
                console.log(it.state)
            })
        }

        console.log(`After State Filter`, this.mFilteredData.length)
        this.dataSource = new MatTableDataSource(this.mFilteredData)
        this.dataSource.paginator = this.paginator
    }

    private processChartData() {
        const challenges: string[] = [];
        const states: string[] = [];
        const dep  = this.mFilteredData.filter(x=>x.challengesFaced.includes('Depression'))
        console.log('depressions entries')
        this.mFilteredData.forEach(item => {
            if (item.challengesFaced && Array.isArray(item.challengesFaced)) {
                challenges.push(...item.challengesFaced);
            }
            if (item.state) {
                states.push(item.state);
            }
        });

        const frequencyMap = this.countFrequency(challenges);
        const stateFrequencyMap = this.countFrequency(states);

        const mChallengesLabels = Array.from(frequencyMap.keys());
        const mChallengesLabelCounts = Array.from(frequencyMap.values());

        const mStateLabels = Array.from(stateFrequencyMap.keys());
        const mStateLabelCounts = Array.from(stateFrequencyMap.values());

        this.showChallengesChart(mChallengesLabels, mChallengesLabelCounts);
        // this.showStatesChart(mStateLabels, mStateLabelCounts);
        console.log('before state chart',this.mFilteredData)
        this.showStatesChart(this.mFilteredData);

        this.dataSource = new MatTableDataSource<any>(this.mFilteredData);
    }

    private showStatesChart(mFilteredData: { state?: string; centreName: string }[]) {
        // 1. Object initialization with default values
        const stateCentreCounts: Record<string, Record<string, number>> = {};

        // 2. Iterate and count occurrences with optional chaining
        mFilteredData.forEach(item => {
            const { state = 'NA', centreName } = item;

            if (state && centreName) {
                stateCentreCounts[state] = stateCentreCounts[state] || {};
                stateCentreCounts[state][centreName] = (stateCentreCounts[state][centreName] || 0) + 1;
            }
        });

        const states = Object.keys(stateCentreCounts);
        const colorPalette = this.generateColorPalette(states.length);

        // 3. Collect all unique centres using a Set
        const allCentres = new Set<string>();
        mFilteredData.forEach(item => {
            if (item.centreName) {
                allCentres.add(item.centreName);
            }
        });

        // 4. Create data for each unique centre
        const series: { name: string; data: number[]; color: string }[] = [];
        for (const centre of allCentres) {
            const data = states.map(state => stateCentreCounts[state]?.[centre] ?? 0);
            series.push({ name: centre, data, color: colorPalette[series.length] });
        }
        console.log('series', series)
        // Configure chart options
        this.stateChartOptions = {
            series: series,
            chart: {
                height: 350,
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                },
                foreColor: '#9aa0ac',
            },
            colors: ['#0e28a6', '#e83108'],
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: 'smooth',
            },
            xaxis: {
                type: 'category',
                categories: states,
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                offsetX: 0,
                offsetY: 0,
            },
            grid: {
                show: true,
                borderColor: '#9aa0ac',
                strokeDashArray: 1,
            },
            tooltip: {
                theme: 'dark',
                marker: {
                    show: true,
                },
                x: {
                    show: true,
                },
            },
        };

        this.mShowStatesChart = true;
    }

    private showStatesChart55(mFilteredData: any[]) {
        // Initialize objects to store counts for each state and centre combination
        const stateCentreCounts: { [key: string]: { [key: string]: number } } = {};
// const totalPune = mFilteredData.filter(x=>x.centreName =='AL Pune').length
//         console.log('totalPune found '+totalPune + 'times')

        // Iterate through mFilteredData to count occurrences of each state for each centre
        mFilteredData.forEach(item => {
            const {state, centreName} = item;
            const stateValue = state || 'NA';


            if (stateValue && centreName) {

                stateCentreCounts[stateValue] ??= {};
                stateCentreCounts[stateValue][centreName] ??= 0;
                stateCentreCounts[stateValue][centreName]++;
            }
        });
        const states = Object.keys(stateCentreCounts);

        const colorPalette = this.generateColorPalette(states.length);
        console.log('statecentrecounts',stateCentreCounts)
        console.log('states',states)
        // Prepare data for the chart
        // const series: any[] = Object.keys(stateCentreCounts[states[0]]).map((centre, i) => {
        //     const data = states.map(state => stateCentreCounts[state][centre] || 0);
        //     return { name: centre, data: data, color: colorPalette[i] };
        // });
        const series: any[] = []; // Initialize an empty series array

        const allCentres = new Set(); // Set to store unique centres

// Loop through states to collect unique centres
        for (const state of states) {
            console.log('centre in state',...Object.keys(stateCentreCounts[state]))
            // @ts-ignore
            allCentres.add(...Object.keys(stateCentreCounts[state])); // Add unique centres from each state
        }
        console.log('ALL CENTRES IN STATE CHART',allCentres)
// Create data for each unique centre
        for (const centre of allCentres) {
            console.log('centre',centre)
            // @ts-ignore
            const data = states.map((state) => stateCentreCounts[state][centre] || 0);

            series.push({name: centre, data: data, color: colorPalette[series.length]}); // Use series.length for color assignment

        }

        console.log('series', series)
        // Configure chart options
        this.stateChartOptions = {
            series: series,
            chart: {
                height: 350,
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                },
                foreColor: '#9aa0ac',
            },
            colors: ['#0e28a6', '#e83108'],
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: 'smooth',
            },
            xaxis: {
                type: 'category',
                categories: states,
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                offsetX: 0,
                offsetY: 0,
            },
            grid: {
                show: true,
                borderColor: '#9aa0ac',
                strokeDashArray: 1,
            },
            tooltip: {
                theme: 'dark',
                marker: {
                    show: true,
                },
                x: {
                    show: true,
                },
            },
        };

        this.mShowStatesChart = true;
    }

    private showStatesChart3(mFilteredData: any[]) {
        // Initialize objects to store counts for each state and centre combination
        const stateCentreCounts: { [key: string]: { [key: string]: number } } = {};

        // Iterate through mFilteredData to count occurrences of each state for each centre
        mFilteredData.forEach(item => {
            const state = item.state;
            const centre = item.centreName;

            // Ensure that the state and centre properties exist
            if (state && centre) {
                if (!stateCentreCounts[state]) {
                    stateCentreCounts[state] = {};
                }
                if (!stateCentreCounts[state][centre]) {
                    stateCentreCounts[state][centre] = 0;
                }
                stateCentreCounts[state][centre]++;
            }
        });

        // Extract unique centres and states
        const centres = Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[0]]);
        const states = Object.keys(stateCentreCounts);

        // Prepare data for the chart
        const series: any[] = [];
        states.forEach(state => {
            const data: any[] = [];
            centres.forEach(centre => {
                data.push(stateCentreCounts[state][centre] || 0);
            });
            series.push({name: state, data: data});
        });

        // Configure chart options
        this.stateChartOptions = {
            series: series,
            chart: {
                height: 350,
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                },
                foreColor: '#9aa0ac',
            },
            colors: ['#0e28a6', '#e83108'],
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: 'smooth',
            },
            xaxis: {
                type: 'category',
                categories: centres,
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                offsetX: 0,
                offsetY: 0,
            },
            grid: {
                show: true,
                borderColor: '#9aa0ac',
                strokeDashArray: 1,
            },
            tooltip: {
                theme: 'dark',
                marker: {
                    show: true,
                },
                x: {
                    show: true,
                },
            },
        };

        this.mShowStatesChart = true;
    }

    private showStatesChartxxx(mFilteredData: any[]) {
        // Initialize objects to store counts for each state and centre combination
        const stateCentreCounts: { [key: string]: { [key: string]: number } } = {};

        // Iterate through mFilteredData to count occurrences of each state for each centre


        //?
        //  mFilteredData.forEach(item => {
        //      if (item.state==null) item.state=='NA'
        //      const state = item.state||'NA';
        //      const centre = item.centreName;
        //
        //      // Ensure that the state and centre properties exist
        //      if (state && centre) {
        //          if (!stateCentreCounts[state]) {
        //              stateCentreCounts[state] = {};
        //          }
        //          if (!stateCentreCounts[state][centre]) {
        //              stateCentreCounts[state][centre] = 0;
        //          }
        //          stateCentreCounts[state][centre]++;
        //      }
        //  });
//?
//         mFilteredData.sort((a, b) => {
//             const stateA = a.state || 'NA';
//             const stateB = b.state || 'NA';
//             return stateA.localeCompare(stateB);
//         });
        mFilteredData.forEach(item => {
            const {state, centreName} = item;
            const stateValue = state || 'NA';

            if (stateValue && centreName) {
                stateCentreCounts[stateValue] ??= {};
                stateCentreCounts[stateValue][centreName] ??= 0;
                stateCentreCounts[stateValue][centreName]++;
            }
        });
        // Extract unique centres and states
        console.log(Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[0]]))
        console.log(Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[1]]))
        console.log(Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[2]]))
        console.log(Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[3]]))
        console.log(Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[4]]))

        let centres = Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[0]]);
        // let centres = Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[4]]);
        // if(this.selectedCentreCode && this.selectedCentreCode?.length>=1){
        //     centres = this.selectedCentreCode!!
        // }
        const states = Object.keys(stateCentreCounts);
        const colorPalette = this.generateColorPalette(centres.length);
        // Prepare data for the chart
        const series: any[] = [];
        console.log('centres in showStates Chart', centres)
        centres.forEach((centre, i: number) => {
            const data: any[] = [];
            states.forEach((state) => {
                data.push(stateCentreCounts[state][centre] || 0);
            });
            series.push({name: centre, data: data, color: colorPalette[i]});
        });

        // Generate color palette dynamically based on the number of unique centres
        // Configure chart options
        this.stateChartOptions = {
            series: series,
            chart: {
                height: 350,
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                },
                foreColor: '#9aa0ac',
            },
            colors: ['#0e28a6', '#e83108'],
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: 'smooth',
            },
            xaxis: {
                type: 'category',
                categories: states,
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                offsetX: 0,
                offsetY: 0,
            },
            grid: {
                show: true,
                borderColor: '#9aa0ac',
                strokeDashArray: 1,
            },
            tooltip: {
                theme: 'dark',
                marker: {
                    show: true,
                },
                x: {
                    show: true,
                },
            },
        };

        this.mShowStatesChart = true;
    }


    private countFrequency(items: string[]) {
        return items.reduce((map, item) => {
            map.set(item, (map.get(item) || 0) + 1);
            return map;
        }, new Map<string, number>());
    }

    private generateColorPalette(numColors: number): string[] {
        // Define a set of predefined colors or generate them dynamically
        const predefinedColors = ['#0e28a6', '#e83108', '#0abf3e', '#e8910a', '#6a0abf', '#0abfbf', '#bf0a4a'];
        const colorPalette: string[] = [];

        // If the number of colors required exceeds the predefined set, generate additional colors
        for (let i = 0; i < numColors; i++) {
            colorPalette.push(predefinedColors[i % predefinedColors.length]);
        }

        return colorPalette;
    }

  protected readonly join = join;
}
